import React, { Fragment, useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Row, Container, CardBody, Col, Card } from 'reactstrap';
import ReactRouterPropTypes from 'react-router-prop-types';
import PropTypes from 'prop-types';
import format from 'date-fns/format';
import AssignmentIcon from '@material-ui/icons/Assignment';
import DeleteIcon from '@material-ui/icons/Delete';
import { showNotificationAutoDestroy } from '../../shared/components/ShowNotification';
import GraphQl from '../../GraphQL';
import {
  inactivateStudents,
  studentListByFilter,
} from '../../shared/queries/Student';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../redux/actions/loadingActions';
import {
  DEFAULT_PAGE_SIZE,
  REPORT_TYPES,
  REPORT_PARAMETERS,
  ACTION_NAME,
} from '../../shared/utils/constants';
import StudentFilter from './components/StudentFilter';
import MaterialTable from '../../shared/components/material-table';
import columns from './components/Columns';
import { concatPhones } from '../../shared/format/format';
import { classListActivesByFunc } from '../../shared/queries/SchoolClass';
import { responsibleListAllQuery } from '../../shared/queries/Responsible';
import { menuListByFilterQuery } from '../../shared/queries/Menu';
import {
  generateReport,
  openReport,
  getUTCDateFromMilliseconds,
} from '../../shared/utils/smartutils';
import PrintSchoolIdModal from './components/PrintSchoolIdModal';
import Modal from '../../shared/components/Modal';

const Student = (props) => {
  const [data, setData] = useState([]);
  const { t, history, dispatch } = props;
  const [filterisOpen, setFilterIsOpen] = useState();
  const [lastFilter, setLastFilter] = useState(null);
  const [classes, setClasses] = useState([]);
  const [responsibles, setResponsibles] = useState([]);
  const [menus, setMenus] = useState([]);
  const [printSchoolIdModal, setPrintSchoolIdModal] = useState(false);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [modal, setModal] = useState(false);

  function showLoading() {
    dispatch(changeLoadingTrue());
  }

  function hideLoading() {
    dispatch(changeLoadingFalse());
  }

  const togglePrintSchoolIdModal = () => {
    setPrintSchoolIdModal(!printSchoolIdModal);
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  const addItemClickHandler = () => {
    history.push('/minime/aluno/mnt/0');
  };

  const editItemClickHandler = (evt, rowData) => {
    history.push(`/minime/aluno/mnt/${rowData.id}`);
  };

  const onFilterToggle = () => {
    setFilterIsOpen(!filterisOpen);
  };

  const listClasses = () => {
    const query = classListActivesByFunc();
    GraphQl(query, {}).then((res) => {
      res.classListActivesByFunc = res.classListActivesByFunc.map((item) => ({
        ...item,
        label: item.name,
        value: item.id,
      }));
      setClasses(res.classListActivesByFunc);
    });
  };

  const listResponsibles = () => {
    const query = responsibleListAllQuery();
    GraphQl(query, {}).then((res) => {
      res.responsibleListAll = res.responsibleListAll.map((item) => ({
        ...item,
        label: item.fullName,
        value: item.id,
      }));
      setResponsibles(res.responsibleListAll);
    });
  };

  const listAllMenus = () => {
    const filter = {
      id: 0,
      active: false,
      inDetail: false,
      studentQuantity: 0,
      deleted: false,
      filterByStatus: false,
      updaterId: 0,
    };
    const query = menuListByFilterQuery(filter);
    GraphQl(query, {}).then((res) => {
      res.menuListByFilter = res.menuListByFilter.map((item) => ({
        ...item,
        label: item.name,
        value: item.id,
      }));

      setMenus(res.menuListByFilter);
    });
  };

  const loadAllStudents = (filter) => {
    if (filterisOpen) {
      onFilterToggle();
    }
    const query = studentListByFilter(filter);
    showLoading();
    GraphQl(query, {})
      .then((res) => {
        res.studentListByFilter = res.studentListByFilter.map((item) => ({
          ...item,
          formattedDateOfBirth: format(
            getUTCDateFromMilliseconds(item.dateOfBirth),
            'dd/MM/yyyy'
          ),
          phones: concatPhones(item),
          studentOrigin: {
            value: item.studentOrigin,
            label: t(`agreement.${item.studentOrigin}`),
          },
          activeDescription: t(`general.yesno.${item.active}`),
        }));
        setData(res.studentListByFilter);
        hideLoading();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const onFilterClickHandler = (filter) => {
    if (filter) {
      setLastFilter(filter);
      loadAllStudents(filter);
    } else if (lastFilter) {
      loadAllStudents(lastFilter);
    } else {
      loadAllStudents({
        id: 0,
        classes: [],
        responsibles: [],
        menus: [],
        onlyActive: true,
      });
    }
  };

  const filterBuildFunction = () => (
    <StudentFilter
      isFiltering={filterisOpen}
      filterClick={onFilterClickHandler}
      lastFilter={lastFilter}
      classes={classes}
      responsibles={responsibles}
      menus={menus}
    />
  );

  const printSchoolId = (rowData) => {
    setSelectedStudents(rowData);
    togglePrintSchoolIdModal();
  };

  const inactivateStudent = () => {
    toggleModal();
    showLoading();
    const query = inactivateStudents(selectedStudents);
    GraphQl(query, {})
      .then(() => {
        loadAllStudents({
          id: 0,
          classes: [],
          responsibles: [],
          menus: [],
          onlyActive: true,
        });
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
    hideLoading();
  };

  const customActions = [
    {
      name: ACTION_NAME.CARD,
      icon: () => <AssignmentIcon />,
      toolbarOnSelect: true,
      tooltip: t('screens.mnt_alunos.printCard'),
      onClick: (event, rowData) => {
        printSchoolId(rowData);
      },
    },
    {
      name: ACTION_NAME.REMOVE,
      icon: () => <DeleteIcon />,
      toolbarOnSelect: true,
      tooltip: t('general.tables.inactivate_registry'),
      onClick: (event, rowData) => {
        setSelectedStudents(rowData);
        toggleModal();
      },
    },
  ];

  const printRegistrationForm = async (e, rowData) => {
    const formData = new FormData();

    formData.append(REPORT_PARAMETERS.REPORTTYPE, REPORT_TYPES.RELA_FICHAA);
    formData.append(REPORT_PARAMETERS.pCO90ALUN, rowData.id);

    showLoading();
    generateReport(formData)
      .then(async (res) => {
        openReport(res.data);
        hideLoading();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('report.error-generate')
        );
      });
  };

  useEffect(() => {
    listClasses();
    listResponsibles();
    listAllMenus();
    loadAllStudents({
      id: 0,
      classes: [],
      responsibles: [],
      menus: [],
      onlyActive: true,
    });
  }, []);

  return (
    <Fragment>
      <Container>
        <PrintSchoolIdModal
          title={t('screens.mnt_alunos.cardPrinting')}
          modal={printSchoolIdModal}
          toggle={togglePrintSchoolIdModal}
          students={selectedStudents}
          showLoading={showLoading}
          hideLoading={hideLoading}
        />
        <Modal
          color="warning"
          title={t('notifications.attention')}
          btn="Warning"
          message={t('notifications.inactivate-students')}
          toggle={toggleModal}
          modal={modal}
          onConfirm={inactivateStudent}
        />
        <Row className="Table">
          <Col md={12} lg={12}>
            <Card>
              <CardBody className="material-table-card">
                <div className="material-table__wrap">
                  <MaterialTable
                    showFilter
                    data={data}
                    isFiltering={filterisOpen}
                    filterToggle={onFilterToggle}
                    filterBuildFunction={filterBuildFunction}
                    onPrintClick={printRegistrationForm}
                    onCardClick={printSchoolId}
                    onRefreshClick={onFilterClickHandler}
                    columns={columns(t)}
                    pageSize={DEFAULT_PAGE_SIZE}
                    selection
                    onAddClick={addItemClickHandler}
                    onEditClick={editItemClickHandler}
                    title={t('panels.aluno')}
                    customActions={customActions}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

Student.propTypes = {
  t: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(Student)
);
